import React, { Component } from 'react';
import { Select, Divider, Spin, Button, Typography } from 'antd';
import soap_centro from '../store/soap/zws_app_buscar_centro.js';

const Option = Select.Option;
const { Title } = Typography;

export default class NewReasearch extends Component {

  state = { 
    centros: [],
    centros_select: [],
    load: false,
    value: undefined,
  };

  async componentDidMount() {

    let _centros = await soap_centro.getCentro();

    // group by
    let centros_werks = [];
    _centros = _centros.filter(c => {
      if (c.WERKS._text) {
        if(centros_werks.indexOf(c.WERKS._text) === -1) {
          centros_werks.push(c.WERKS._text);
          return c;
        }
      }
    })

    this.setState({
      load: true,
      centros: _centros,
      centros_select: _centros.slice(0, 10)
    });

  }

  salveCentro = e => {
    if( this.state.value===undefined) {
      return;
    }
    localStorage.setItem('centro', this.state.value);
    this.props.history.push('/')
  }

  handleChange = value => {
    this.setState({ value });
  };

  render() {
    return (
      <>
        <Title level={3}>NOVA PESQUISA</Title>
        <Divider orientation="left">Selecione um centro</Divider>
        {this.state.load && <Select
          showSearch
          value={this.state.value}
          onChange={this.handleChange}
          style={{ width: '100%'}}
          placeholder="Selecione"
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {this.state.centros.map(centro => (
            <Option key={centro.WERKS._text}>{centro.NAME1._text}</Option>
          ))}
        </Select>
        }

        {
          !this.state.load &&
          <Spin className="spin-dma" />
        }
    
        <Button type="primary" icon="check" size="large" block style={{ marginTop: 10 }} onClick={this.salveCentro} className="dma-primary">INICIAR PESQUISA</Button>

      </>
    );
  }
};